/*
 * @Author: Dom
 * @Date: 2022-05-26 13:43:53
 * @LastEditTime: 2022-06-30 14:00:54
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\area.ts
 */
import request from '@/utils/request'
import {AreaParams} from '@/services/data.d'

export async function getArea(params:AreaParams): Promise<any>{
    return request({
        url: '/seller/v1/area/getAreaList',
        method: 'GET',
        params
    })
}
